<div class="header">
    <div class="headerContent">
        <h1 mat-dialog-title>Bemerkung</h1>   
    </div>
    <div class="headerContent">
        <button mat-icon-button matDialogClose matTooltip="Schließen" aria-label="Schließen">
            <fa-icon icon="times" size="2x"></fa-icon>
        </button>
    </div>
</div>
<mat-dialog-content>
    <form [formGroup]="FileForm">
        <app-textarea Key="Bemerkung" [Value]="FileForm.controls.Remark"></app-textarea>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <button app-button matDialogClose Color="cancel" Inverted>Abbrechen</button>
    <button app-button Color="green" (click)="Submit()">Speichern</button>
</mat-dialog-actions>